export const getElementVisibleHeight = (element: HTMLDivElement | null): number => {
  const { top, bottom } = element?.getBoundingClientRect() || { top: 0, bottom: 0 };
  const safeTop = Math.max(0, top);
  const safeBottom = Math.min(bottom, window.innerHeight);

  return Math.max(safeBottom - safeTop, 0);
};
